import CustomersTable from './_table.js'
import template from './call-center-index.pug'

export default Vue.extend({
  template: template(),
  components: {
    CustomersTable
  },
  data() {
    return {
      customers: [],
      meta: {},
      ready: false
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.loadCallCenter()
      }
    }
  },
  methods: {
    loadCallCenter() {
      this.ready = false
      API.callCenters.show(this.$route.params.id).then(callCenter => {
        this.$setPageTitle(this.$t('customers.callCenter.title', {name: callCenter.name}))
        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.callCenters.index'), route: {name: 'call-centers-index'}},
          {
            label: this.$t('breadcrumbs.callCenters.show', {name: callCenter.name}),
            route: {name: 'call-centers-show', params: {id: callCenter.id}}
          },
          {
            label: this.$t('breadcrumbs.callCenters.customers', {name: callCenter.name}),
            route: {}
          }
        ])

        this.ready = true
      })
    },

    loadCustomers(queryOptions = {}) {
      queryOptions.filter = queryOptions.filter || {}
      queryOptions.filter.callCenterId = [this.$route.params.id]

      API.customers.index(queryOptions).then(({data, meta}) => {
        this.customers = data
        this.meta = meta
      })
    }
  }
})
